import React, { useState } from 'react';
import { FaTrash, FaEdit } from 'react-icons/fa';
import { MdAdd } from 'react-icons/md';
import '../Styles/UserTypes.css';
import { useSidebar } from '../Layout/SidebarContext';

const Configure = () => {
  const { isConfigOpen } = useSidebar();

  const [organizations] = useState(['Neviton', 'Strides', 'Arcolab']);
  const [bankName] = useState(['HDFC Bank', 'ABC Bank', 'XYZ Bank']);
  const [userTypes] = useState(['AWS Account Manager', 'Neviton', 'Customer']);
  const [solutions] = useState(['Greenfield Landing Zone Solution', 'Landing Zone and Tower Migration']);
  const [time] = useState(['1 Week', '2 Weeks', '3 Weeks']);
  const [price] = useState(['100 USD', '200 USD', '300 USD']);

  const [selectedOrganization, setSelectedOrganization] = useState('');
  const [selectedBank, setSelectedBank] = useState('');
  const [selectedUserType, setSelectedUserType] = useState('');
  const [selectedSolution, setSelectedSolution] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [selectedPrice, setSelectedPrice] = useState('');

  const [configurations, setConfigurations] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editDetails, setEditDetails] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const existingData = [
    {
      "id": 1,
      "organization": "Neviton",
      "userType": "AWS Account Manager",
      "solution": "Greenfield Landing Zone Solution",
      "time": "3 Weeks",
      "price": "100 USD",
      "bankDetails": "ABC Bank",
      "editedBy": "Ameena",
      "editedAt": "30-09-2023"
    },
    {
      "id": 2,
      "organization": "Strides",
      "userType": "Customer",
      "solution": "Landing Zone to Control Tower Migration",
      "time": "2 Weeks",
      "price": "50 USD",
      "bankDetails": "XYZ Bank",
      "editedBy": "John",
      "editedAt": "15-10-2023"
    },
    {
      "id": 3,
      "organization": "Neviton",
      "userType": "Neviton",
      "solution": "Greenfield Landing Zone Solution",
      "time": "3 Weeks",
      "price": "100 USD",
      "bankDetails": "ABC Bank",
      "editedBy": "Ananya",
      "editedAt": "07-12-2023"
    },
    {
      "id": 4,
      "organization": "Neviton",
      "userType": "AWS Account Manager",
      "solution": "Landing Zone to Control Tower Migration",
      "time": "3 Weeks",
      "price": "100 USD",
      "bankDetails": "XYZ Bank",
      "editedBy": "Ameena",
      "editedAt": "30-09-2023"
    },
    {
      "id": 5,
      "organization": "Strides",
      "userType": "Customer",
      "solution": "Greenfield Landing Zone Solution",
      "time": "2 Weeks",
      "price": "50 USD",
      "bankDetails": "ABC Bank",
      "editedBy": "Ananya",
      "editedAt": "15-10-2023"
    },
    {
      "id": 6,
      "organization": "Neviton",
      "userType": "AWS Account Manager",
      "solution": "Landing Zone to Control Tower Migration",
      "time": "3 Weeks",
      "price": "100 USD",
      "bankDetails": "XYZ Bank",
      "editedBy": "Ananya",
      "editedAt": "07-12-2023"
    },
    {
      "id": 7,
      "organization": "Strides",
      "userType": "Customer",
      "solution": "Greenfield Landing Zone Solution",
      "time": "2 Weeks",
      "price": "50 USD",
      "bankDetails": "ABC Bank",
      "editedBy": "John",
      "editedAt": "15-10-2023"
    },
    {
      "id": 8,
      "organization": "Neviton",
      "userType": "Neviton",
      "solution": "Landing Zone to Control Tower Migration",
      "time": "3 Weeks",
      "price": "100 USD",
      "bankDetails": "XYZ Bank",
      "editedBy": "Ameena",
      "editedAt": "30-09-2023"
    },
    {
      "id": 9,
      "organization": "Neviton",
      "userType": "AWS Account Manager",
      "solution": "Greenfield Landing Zone Solution",
      "time": "3 Weeks",
      "price": "100 USD",
      "bankDetails": "ABC Bank",
      "editedBy": "Ananya",
      "editedAt": "07-12-2023"
    },
    {
      "id": 10,
      "organization": "Strides",
      "userType": "Customer",
      "solution": "Landing Zone to Control Tower Migration",
      "time": "2 Weeks",
      "price": "50 USD",
      "bankDetails": "XYZ Bank",
      "editedBy": "Ameena",
      "editedAt": "15-10-2023"
    }
  ];
  

  const handleConfigure = () => {
    if (!selectedOrganization || !selectedBank || !selectedUserType || !selectedSolution || !selectedTime || !selectedPrice) {
      alert('Please select an organization, user type, solution, time and price.');
      return;
    }

    const matchedData = existingData.filter(
      (data) =>
        data.organization === selectedOrganization &&
        data.bankDetails === selectedBank &&
        data.userType === selectedUserType &&
        data.solution === selectedSolution &&
        data.time === selectedTime &&
        data.price === selectedPrice
    );

    if (matchedData.length > 0) {
      setConfigurations(matchedData);
    } else {
      alert('No matching data found.');
    }
  };

  const handleEdit = (item) => {
    setIsEditing(true);
    setEditDetails(item);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveEdit = () => {
    setConfigurations((prev) =>
      prev.map((item) =>
        item.id === editDetails.id ? { ...editDetails } : item
      )
    );
    setIsEditing(false);
    setEditDetails(null);
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setConfirmDelete(true);
  };

  const handleConfirmDelete = () => {
    setConfigurations((prev) =>
      prev.filter((item) => item.id !== deleteId)
    );
    setConfirmDelete(false);
    setDeleteId(null);
  };

  const handleCancelDelete = () => {
    setConfirmDelete(false);
    setDeleteId(null);
  };

  return (
    <div className={`user-types-container ${isConfigOpen ? 'shifted-right' : ''}`}>
      <div className="heading">
        <h2>Configure Settings</h2>
      </div>

      <div className="solution-selection-dropdown">
        <div className="dropdown-row">
          {/* Organization and User Type */}
          <select
            onChange={(e) => setSelectedOrganization(e.target.value)}
            value={selectedOrganization}
          >
            <option value="">Select Organization</option>
            {organizations.map((org, index) => (
              <option key={index} value={org}>
                {org}
              </option>
            ))}
          </select>

          <select
            onChange={(e) => setSelectedUserType(e.target.value)}
            value={selectedUserType}
          >
            <option value="">Select User Type</option>
            {userTypes.map((type, index) => (
              <option key={index} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        <div className="dropdown-row">
          {/* Solution and Time */}
          <select
            onChange={(e) => setSelectedSolution(e.target.value)}
            value={selectedSolution}
          >
            <option value="">Select Solution</option>
            {solutions.map((sol, index) => (
              <option key={index} value={sol}>
                {sol}
              </option>
            ))}
          </select>

          <select
            onChange={(e) => setSelectedTime(e.target.value)}
            value={selectedTime}
          >
            <option value="">Select Time</option>
            {time.map((tim, index) => (
              <option key={index} value={tim}>
                {tim}
              </option>
            ))}
          </select>
        </div>

        <div className="dropdown-row">
          {/* Price and Bank */}
          <select
            onChange={(e) => setSelectedPrice(e.target.value)}
            value={selectedPrice}
          >
            <option value="">Select Price</option>
            {price.map((pric, index) => (
              <option key={index} value={pric}>
                {pric}
              </option>
            ))}
          </select>

          <select
            onChange={(e) => setSelectedBank(e.target.value)}
            value={selectedBank}
          >
            <option value="">Select Bank</option>
            {bankName.map((bank, index) => (
              <option key={index} value={bank}>
                {bank}
              </option>
            ))}
          </select>

        </div>
        <div>
          <button className='save-btn' onClick={handleConfigure}>Configure</button>
        </div>   
      </div>


      {/* Table */}
      {configurations.length > 0 ? (
        <div className="user-types-table">
          <table>
            <thead>
              <tr>
                <th>Actions</th>
                <th>Organization</th>
                <th>User Type</th>
                <th>Solution</th>
                <th>Time</th>
                <th>Price</th>
                <th>Bank</th>
                <th>Edited By</th>
                <th>Edited At</th>
              </tr>
            </thead>
            <tbody>
              {configurations.map((entry) => (
                <tr key={entry.id}>
                  <td>
                    <FaEdit size={15} onClick={() => handleEdit(entry)} style={{ cursor: 'pointer', color: '#00bfa5' }} />
                    <FaTrash size={15} onClick={() => handleDelete(entry.id)} style={{ cursor: 'pointer', color: '#f44336' }} />
                  </td>
                  <td>{entry.organization}</td>
                  <td>{entry.userType}</td>
                  <td>{entry.solution}</td>
                  <td>{entry.time}</td>
                  <td>{entry.price}</td>
                  <td>{entry.bankDetails}</td>
                  <td>{entry.editedBy}</td>
                  <td>{entry.editedAt}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No configurations found</p>
      )}

      {/* Edit Modal */}
      {isEditing && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Edit Details</h3>
            <form>
              <label>
                Organization:
                <input
                  type="text"
                  name="organization"
                  value={editDetails.organization}
                  onChange={handleEditChange}
                />
              </label>
              <label>
                User Type:
                <input
                  type="text"
                  name="userType"
                  value={editDetails.userType}
                  onChange={handleEditChange}
                />
              </label>
              <label>
                Solution:
                <input
                  type="text"
                  name="solution"
                  value={editDetails.solution}
                  onChange={handleEditChange}
                />
              </label>
              <label>
                Time:
                <input
                  type="text"
                  name="time"
                  value={editDetails.time}
                  onChange={handleEditChange}
                />
              </label>
              <label>
                Price:
                <input
                  type="text"
                  name="price"
                  value={editDetails.price}
                  onChange={handleEditChange}
                />
              </label>
              <label>
                Bank Details:
                <input
                  type="text"
                  name="bankDetails"
                  value={editDetails.bankDetails}
                  onChange={handleEditChange}
                />
              </label>
              <div className="modal-actions">
                <button type="button" onClick={handleSaveEdit}>
                  Save
                </button>
                <button type="button" onClick={() => setIsEditing(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Confirm Delete Modal */}
      {confirmDelete && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Are you sure you want to delete this option?</h3>
            <div className="modal-actions">
              <button onClick={handleConfirmDelete}>Yes, Delete</button>
              <button onClick={handleCancelDelete}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Configure;
